import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">韩漫网站</Link>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汇聚众多精彩韩漫作品，免费阅读配合流畅下拉式浏览，智能加载技术确保您在各类设备上获得极致体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-100">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">全部分类</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">奇幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-100">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">悬疑漫画</Link></li>
              <li><Link to="/category/drama" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">剧情漫画</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">搞笑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-100">关于</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><span className="text-sm text-foreground-300">联系邮箱：contact@hanman.site</span></li>
              <li><span className="text-sm text-foreground-300">服务时间：7×24小时</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 韩漫网站 - 好看的韩国漫画，韩漫免费阅读漫画，下拉式韩漫在线。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}